import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSendJetonbankWallet = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 176,
	height: 176,
	viewBox: "0 0 176 176",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter_send_jetonbank_wallet)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 88,
				cy: 88,
				r: 63,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("svg", {
			x: 63,
			y: 63,
			width: 50,
			height: 50,
			viewBox: "8.16 10.51 21.2 21.2",
			preserveAspectRatio: "xMidYMid meet",
			fill: "none",
			...props,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M24.5052 12.0009V24.69C24.5052 26.5323 23.8893 27.7606 22.862 28.7835C21.8355 29.8073 20.3967 30.217 18.7526 30.217C16.9032 30.217 15.6706 29.8073 14.4379 28.7835C13.6168 27.965 13 26.5323 13 24.69H16.6988C16.6988 25.5085 16.9041 26.1235 17.3147 26.5323C17.7252 26.9412 18.1367 27.1464 18.9579 27.1464C19.5746 27.1464 20.1914 26.9412 20.3967 26.5323C20.602 26.1226 20.8073 25.5085 20.8073 24.8953V12H24.5061L24.5052 12.0009Z",
				fill: "#131E3D"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter_send_jetonbank_wallet",
			x: 0,
			y: 0,
			width: 176,
			height: 176,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 12.5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.18 0 0 0 0 0.206667 0 0 0 0 0.22 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgSendJetonbankWallet;
